"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClipboard = void 0;
const react_1 = require("react");
const hooks_1 = require("common/hooks");
const standard_1 = require("react-hook-schema/standard");
const log_1 = require("common/log");
const useClipboard = () => {
    const alert = (0, standard_1.useAlert)();
    const [clipboardContent, setClipboardContent] = (0, react_1.useState)();
    const [clipboardPermission, setClipboardPermission] = (0, react_1.useState)(undefined);
    const [localClipboardContent, setLocalClipboardContent] = (0, hooks_1.useLocalStorage)("__clipboardContent", undefined);
    const updatePermission = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const permission = yield navigator.permissions.query({
            name: "clipboard-read",
        });
        setClipboardPermission(permission.state);
        return permission.state;
    }), []);
    (0, react_1.useEffect)(() => {
        updatePermission();
    }, []);
    (0, react_1.useEffect)(() => {
        if (clipboardPermission !== "granted")
            return;
        console.log("start to observe clipboarde event change");
        const handler = () => __awaiter(void 0, void 0, void 0, function* () {
            console.log("clipboardchange event");
            const text = yield navigator.clipboard.readText();
            setClipboardContent(JSON.parse(text));
        });
        navigator.clipboard.addEventListener("clipboardchange", handler);
        return () => {
            navigator.clipboard.removeEventListener("clipboardchange", handler);
        };
    }, [clipboardPermission]);
    const errorModal = (0, standard_1.useErrorModal)();
    const getContent = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!navigator.clipboard) {
            console.warn("Browser doesn't support clipboard API");
            return;
        }
        try {
            const text = yield navigator.clipboard.readText();
            const content = JSON.parse(text);
            setClipboardContent(content);
            return content || localClipboardContent;
        }
        catch (error) {
            console.error("Failed to read from clipboard:", error);
            return localClipboardContent;
        }
    }), []);
    const setContent = (0, react_1.useCallback)((content) => __awaiter(void 0, void 0, void 0, function* () {
        setLocalClipboardContent(content);
        setClipboardContent(content);
        updatePermission();
        if (!navigator.clipboard) {
            console.warn("Browser doesn't support clipboard API");
            return;
        }
        try {
            yield navigator.clipboard.writeText(JSON.stringify(content));
        }
        catch (error) {
            errorModal({
                error: error,
                internalMessage: "Failed to write to clipboard",
                userMessage: "クリップボードへの書き込みに失敗しました",
            });
            (0, log_1.errorLog)(error);
            console.error("Failed to write to clipboard:", error);
        }
    }), []);
    return {
        content: clipboardPermission === "granted"
            ? clipboardContent
            : localClipboardContent,
        setContent,
        getContent,
        clipboardPermission,
    };
};
exports.useClipboard = useClipboard;
